import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetRuleExecutionResultByIdQuery,
  GetRuleExecutionResultByIdQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { useFetchQuery } from "src/graphql/utils";
import { mapToCase } from "src/mappers/case.mappers";

export const getRuleExecutionResultByIdQuery = gql(/* GraphQL */ `
  query GetRuleExecutionResultById($id: ID!) {
    ruleExecutionResult(id: $id) {
      cases {
        ...CaseFragment
      }
    }
  }
`) as TypedDocumentNode<GetRuleExecutionResultByIdQuery, GetRuleExecutionResultByIdQueryVariables>;

export const useGetRuleExecutionResultByIdQuery = (options: { id: string | undefined }) => {
  return useFetchQuery(getRuleExecutionResultByIdQuery, {
    toData: (data) => data?.ruleExecutionResult?.cases.map(mapToCase) ?? [],
    isEmpty: (data) => !data || !data?.ruleExecutionResult,
    queryOptions: {
      variables: { id: options.id ?? "" },
      skip: !options.id,
    },
    uiErrors: {
      fetchError: "FETCH-RELATED-CASES-ERROR",
    },
  });
};
